export default {
  type: 'String',
  name: 'String',
  domain: 'String',
  data: 'String',
}
